<script setup>
import { storeToRefs } from 'pinia';
import { useTopNavBarStore } from '@/store/topNavBar';
import NavBarTopMobileMenu from '@/components/navbartop/NavBarTopMobileMenu.vue';

const store = useTopNavBarStore();
const { toggleModal } = store;

const {
  leftNav,
  leftNavCustomIcon,
  backFunction,
} = storeToRefs(store);
</script>

<template>
  <v-btn
    v-if="leftNav === 'back'"
    size="x-small"
    variant="tonal"
    icon="mdi-arrow-left"
    data-testid="return"
    @click="backFunction"
  />
  <v-btn
    v-else-if="leftNav === 'close'"
    size="x-small"
    variant="tonal"
    icon="mdi-close"
  />

  <nav-bar-top-mobile-menu v-else-if="leftNav === 'profile'" />

  <v-btn
    v-else-if="leftNav === 'modal'"
    size="x-small"
    variant="tonal"
    :icon="leftNavCustomIcon ?? 'mdi-information-outline'"
    @click="toggleModal"
  />
</template>
